import { useEffect } from 'react'
import { createChannelSubscription } from './cable'
import { applyClinicUpdate } from './clinicUpdate'

const clinicUpdatesChannel = createChannelSubscription('ClinicUpdatesChannel', 'Clinic updates')

export const useClinicUpdates = (enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return

    clinicUpdatesChannel.ensure(message => {
      applyClinicUpdate(message)
    })

    return () => {
      clinicUpdatesChannel.release()
    }
  }, [enabled])
}
